import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TabularComponent } from "./tabular.component";
import { SsgTabsetModule } from "./tabset/tabset.module";
@NgModule({
  imports: [CommonModule, SsgTabsetModule],
  declarations: [TabularComponent],
  exports: [TabularComponent],
})
export class TabularModule {}
